<p-multiSelect 
    [options]="items"
    [(ngModel)]="privilegesSelected"
    [defaultLabel]="processing ? 'Loading..' : defaultLabel"
    [filterPlaceHolder]="filterPlaceHolder"
    placeholder=""
    [disabled]="disabled"
    [maxSelectedLabels]="maxSelectedLabels"
    (onChange)="change($event.value)"
    (onBlur)="blur()"
    styleClass="content-body hide-check">
</p-multiSelect>